import { useDispatch } from 'react-redux';
import { generatePath as generatePathRouter } from 'react-router';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import erik from '../../assetsOld/logo/erikLogo100x200.png';
import { push, RouteRule } from '../../routes/RouteManager';
import t from '../../locations/translations';

const TextColumn = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== 'mobile',
})<{ mobile?: boolean }>`
	flex: 0 0 auto;
	width: auto;
	text-align: ${(props) => (props.mobile ? 'center' : 'start')};
	padding: 10px 0;
	color: gray;
`;

const LogoColumn = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== 'mobile',
})<{ mobile?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 auto;
	width: auto;
	text-align: ${(props) => (props.mobile ? 'center' : 'start')};
	padding: 10px 0;
	color: gray;
`;

const FooterImage = styled.img`
	width: 100%;
	height: 100%;
	max-height: 130px;
	object-fit: contain;
	padding: 15px;
	margin: auto 0;
`;

const TextGroup = styled.div`
	padding: 7px;

	& > div {
		padding: 3px 0;
	}
`;

const Link = styled.div`
	cursor: pointer;
	color: gray;

	&:hover {
		text-decoration: underline;
	}

	a {
		color: gray;
		text-decoration: none;
	}
`;

const FooterContainer = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
	align-items: stretch;
	height: 100%;
	flex-direction: row;
	flex-wrap: wrap;
	padding: 15px 0 0 0;
	border-top: 1px solid #e0e0e0;
`;

const Copyright = styled.div`
	width: 100%;
	padding: 15px;
	font-size: 12px;
	justify-content: center;
	align-items: center;
	border-top: 1px solid #e0e0e0;
	color: gray;
	text-align: center;
`;

const FooterRow = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== 'mobile',
})<{ mobile?: boolean }>`
	display: flex;
	width: 100%;
	flex-wrap: wrap;
	justify-content: ${(props) => (props.mobile ? 'center' : 'space-evenly')};
	flex-direction: ${(props) => (props.mobile ? 'column' : 'row')};
`;

const AppFooter = ({ isMobile }: { isMobile: boolean }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	return (
		<FooterContainer>
			<FooterRow mobile={isMobile}>
				<LogoColumn mobile={isMobile}>
					<FooterImage src={erik} />
				</LogoColumn>
				<TextColumn mobile={isMobile}>
					<h5>Firemne Údaje</h5>
					<TextGroup>
						<div>ERIK s.r.o</div>
					</TextGroup>
					<TextGroup>
						<div>Pri Krásnej 3</div>
						<div>040 12 Košice</div>
					</TextGroup>
					<TextGroup>
						<div>IČO: 36177083</div>
						<div>DIČ: 2020044609</div>
						<div>DIČ DPH: SK 2020044609</div>
					</TextGroup>
				</TextColumn>
				<TextColumn mobile={isMobile}>
					<h5> Informácie pre vas </h5>
					<TextGroup>
						<Link>
							<a href={RouteRule.aboutUs.path}>{t('navigation.aboutUs')}</a>
						</Link>
						{/*<Link>Všeob. obchodné podmienky</Link>*/}
						<Link>
							<a href={RouteRule.privacyPolicy.path}>Ochrana osobných údajov</a>
						</Link>
						{/*<Link>Volne Pracovne pozicie</Link>*/}
						<Link>
							<a href={RouteRule.contact.path}>{t('navigation.contacts')}</a>
						</Link>
					</TextGroup>
				</TextColumn>
			</FooterRow>
			<FooterRow>
				<Copyright>Copyright © {new Date().getFullYear()} erik.sk · Všetky práva vyhradené.</Copyright>
			</FooterRow>
		</FooterContainer>
	);
};

export default AppFooter;
